import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import axios from "axios";
import PaymentForm from "./PaymentForm";
import { useLocation } from "react-router-dom";
 
const stripe = loadStripe('pk_test_51PMWNl03Z7zzZ0S8OdsPfaMXGUQGtLvsDluLEI4vQKkfGTLu8GTG5dD3Nw5qxpmvX4W1FMzJzwNwq6NZKxV4JVRz00xFwGi9Uz');
 
const StripePayment = () => {
    const [clientSecret, setClientSecret] = useState(null);

    const location = useLocation();
    const { items } = location.state || {};

    console.log("Items from location state:", items);

 
    // useEffect(() => {
    //     axios
    //         .post(`${process.env.REACT_APP_API_URL}/create-payment-intent`, {
    //             items: [{ id: 1, name: "", amount: 500.00 }],
    //         })
    //         .then((resp) => setClientSecret(resp.data.clientSecret));
    // }, []);

    useEffect(() => {
    if (!items || items.length === 0) return;

    axios
      .post(`${process.env.REACT_APP_API_URL}/create-payment-intent`, { items })
      .then((resp) => setClientSecret(resp.data.clientSecret))
      .catch((err) => {
        console.error("Error creating payment intent:", err);
      });
  }, [items]);
 
    const options = { 
        clientSecret,
        theme: "stripe",
    }; 
 
    return (
        clientSecret && (
            <Elements stripe={stripe} options={options}>
                <PaymentForm></PaymentForm>
            </Elements>
        )
    );
};
 
export default StripePayment;